import { useQuery } from "react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { SelectionListItem } from "../../../../../Forms/SelectionListItem";
import { minutesAsMilliSeconds } from "../../../../../Utils/time";
import { ttProtectionOdcsAndCrossDocksQueryKey } from "../ttProtectionQueryKey";

export const useFetchOdcsAndCrossDocks = (url: string) => {
  return useQuery<SelectionListItem<string>[], Error>({
    queryKey: ttProtectionOdcsAndCrossDocksQueryKey,
    staleTime: minutesAsMilliSeconds(10),
    cacheTime: minutesAsMilliSeconds(20),
    queryFn: () => fetchOdcsAndCrossDocks(url),
    onError: () => toast.error("An error occurred when retrieving the ODCs and Cross Docks"),
  });
};

const fetchOdcsAndCrossDocks = async (url: string) => {
  const { data: odcsAndCrossDocks } = await axios.get<SelectionListItem<string>[]>(url);
  return odcsAndCrossDocks;
};
